// import analytics from '@utils/analytics';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import Icon from '@stone/ui/icon/Icon';
import Button from '@stone/ui/button/Button';
const FaqSearch = (props) => {
    const { t } = useTranslation();
    const [results, setResults] = useState([]);
    const [query, setQuery] = useState('');
    const searchInput = useRef();
    // add listener from outside via CustomEventBus
    useEffect(() => {
        customEventBus.on('faqSearch:back', () => {
            setResults([]);
            setQuery('');
        });
    }, []);
    useEffect(() => {
        //query in listen per reinit di Swiper in StoriesCarousel, line 47;
        customEventBus.emit('query:update', { query: query });
    }, [query]);
    useEffect(() => {
        customEventBus.emit('faqSearch:update', { results: results });
    }, [results]);
    return (React.createElement("div", { className: "faq-search" },
        React.createElement("div", { className: "form-group", "data-dark": "false" },
            React.createElement("div", { className: "form-control has-buttons" },
                React.createElement("input", { type: "search", id: "hero-searchbar", className: "blockview", placeholder: t('label.search'), "aria-label": t('label.search'), ref: searchInput, 
                    // onFocus={() => {
                    //   analytics.startCSSearch();
                    // }}
                    onChange: (e) => {
                        //@ts-ignore
                        setQuery(e.currentTarget.value);
                    }, value: query, role: "searchbox" }),
                query.length >= 1 ? (React.createElement("button", { onClick: () => {
                        setResults([]);
                        setQuery('');
                        searchInput.current.focus();
                    }, "aria-label": t('button.close'), type: 'submit', className: "button-delete" },
                    React.createElement(Icon, { family: '16', name: 'close' }))) : (React.createElement("button", { tabIndex: -1, "aria-hidden": true, className: "button-search" },
                    React.createElement(Icon, { family: "16", name: "search" })))),
            query.length >= 1 && (React.createElement(Button, { cls: ['button--secondary'], onClick: () => {
                    let resultsSection = document.getElementById('faq-results');
                    resultsSection === null || resultsSection === void 0 ? void 0 : resultsSection.focus();
                }, className: "visible-on-focus", type: 'button' }, t('faqsearch.a11y.toresults'))))));
};
export default FaqSearch;
